import { SupportedMarket } from '@estercare/ester-shared'

export const isSwedishMarket = (userMarket?: SupportedMarket): boolean => userMarket === SupportedMarket.SWEDEN

export const isNorwegianMarket = (userMarket?: SupportedMarket): boolean => userMarket === SupportedMarket.NORWAY

export const isHealthCallsEnabled = (
  userMarket?: SupportedMarket,
  isInvited?: boolean,
  isMaleUser?: boolean
): boolean => !isInvited && isSwedishMarket(userMarket) && !isMaleUser
